// Normalize an offset-less UTC datetime string ("...T..:..:..") to a real UTC instant
const toWATDate = (dateString) => {
  if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(dateString)) {
    return new Date(dateString + 'Z');
  }
  return new Date(dateString);
};

// Format date to DD-MM-YYYY (Nigerian time for timestamps)
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  
  // If the date is already in YYYY-MM-DD format, parse it directly
  // This avoids timezone issues when converting
  if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  }
  
  // For full timestamps, display in Nigerian time (WAT)
  return toWATDate(dateString)
    .toLocaleDateString('en-GB', { timeZone: 'Africa/Lagos', day: '2-digit', month: '2-digit', year: 'numeric' })
    .replace(/\//g, '-');
};

// Format date with time to DD-MM-YYYY HH:MM in Nigerian time (WAT)
export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  const date = toWATDate(dateString);
  const datePart = date
    .toLocaleDateString('en-GB', { timeZone: 'Africa/Lagos', day: '2-digit', month: '2-digit', year: 'numeric' })
    .replace(/\//g, '-');
  const timePart = date
    .toLocaleTimeString('en-GB', { timeZone: 'Africa/Lagos', hour: '2-digit', minute: '2-digit', hour12: false });
  return `${datePart} ${timePart}`;
};

// Format date for input fields (YYYY-MM-DD required by HTML date input)
export const formatDateForInput = (dateString) => {
  if (!dateString) return new Date().toISOString().split('T')[0];
  return dateString;
};

// Format a UTC/ISO timestamp in Nigerian time (WAT, Africa/Lagos) → "16 Jun 2026, 02:30 PM"
export const formatWATDateTime = (dateString) => {
  if (!dateString) return '';
  try {
    return toWATDate(dateString).toLocaleString('en-GB', {
      timeZone: 'Africa/Lagos',
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true
    });
  } catch (e) { return ''; }
};

// Just the time portion in Nigerian time (WAT) → "02:30 PM"
export const formatWATTime = (dateString) => {
  if (!dateString) return '';
  try {
    return toWATDate(dateString).toLocaleTimeString('en-GB', {
      timeZone: 'Africa/Lagos', hour: '2-digit', minute: '2-digit', hour12: true
    });
  } catch (e) { return ''; }
};

// Format currency value with thousand separators and 2 decimal places
// Format: 1,234,567.89
export const formatCurrency = (value) => {
  const num = Number(value) || 0;
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
